
const revision = process.env.VUE_APP_GIT_REVISION;

export default async function () {
  const response = await fetch("/version", {
    cache: "no-cache"
  });
  const serverRevision = (await response.text()).trim();
  console.error(`Client Revision: ${revision}`);
  console.error(`Server Revision: ${serverRevision}`);
  if (revision !== serverRevision) {
    console.error('Not the same, so reloading.');
    if (window.location.href.endsWith('#refresh')) {
      console.error(`Already refreshed, preventing further reloads.`);
    } else {
      window.location.href = window.location.href + '#refresh';
      window.location.reload();
    }
  }
};
